import React, { useState, useEffect } from "react";
import Header from "@Components/Header/Header";
import Footer from "@Components/Footer/Footer";
import { MobHeader } from "@Components/Mob-header/Mob-header";
import Breadcrumb from "@Components/DetailsPageBanner/components/Breadcrumb";
import { getFaqList } from "@Src/features/Home/services/Home.service";
import { FaqCategory } from "@Src/features/Home/services/Home.api.interface";
import "./FAQ.scss";

export const FAQ = () => {
    const Headings = [{ name: "FAQ", type: "FAQ" }];
    const [openIndex, setOpenIndex] = useState<string | null>("");
    const [faqData, setFaqData] = useState<FaqCategory[]>([]);

    useEffect(() => {
        getFaqList().then(response => {
            if (response.success) {
                setFaqData(response.data);
            }
        });
    }, []);

    const toggleAccordion = (index: string) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="faq-page">
            <Header />
            <MobHeader />

            <section className="mock-test-listining-container faq-breadcrumb-section">
                <div className="ia-container">
                    <div className="grid justify-content-between">
                        <div className="col-12 py-2">
                            <div className="pt-4">
                                <Breadcrumb Headings={Headings} />
                            </div>

                            <div className="m-t-l-header text-white pt-3 ml-0">
                                <span>FAQ</span>
                            </div>
                            <div className="text-white opacity-75">
                                Find answers to the most frequently asked questions about iAbhyas and our services.
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="ia-container py-12 lg:py-20">
                <div className="tw-text-center tw-mb-10">
                    <h2 className="tw-text-4xl tw-font-bold tw-text-gray-900 tw-mb-4 tw-mt-10">Frequently Asked Questions</h2>
                    <p className="tw-text-gray-600 tw-max-w-2xl tw-mx-auto">
                        Have more questions about iAbhyas ? Find all your answers here!
                    </p>
                </div>

                <div className="faq-content-container">
                    {faqData.length === 0 ? (
                        <div className="tw-text-center tw-py-12">
                            <p className="tw-text-gray-500 tw-text-lg">No FAQs available at the moment.</p>
                        </div>
                    ) : (
                        faqData.map((section, sectionIndex) => (
                        <div key={sectionIndex} className="faq-section tw-mb-12">
                            <h3 className="category-title tw-text-2xl tw-font-semibold tw-text-gray-800 tw-mb-6">
                                {section.category}
                            </h3>
                            <div className="faq-list">
                                {section.items.map((item, itemIndex) => {
                                    const currentIndex = `${sectionIndex}-${itemIndex}`;
                                    const isOpen = openIndex === currentIndex;
                                    return (
                                        <div
                                            key={itemIndex}
                                            className={`faq-card tw-mb-4 tw-rounded-xl tw-border tw-border-gray-100 tw-bg-white tw-shadow-sm tw-overflow-hidden tw-transition-all ${isOpen ? 'active' : ''}`}
                                        >
                                            <button
                                                className="faq-header tw-w-full tw-flex tw-items-center tw-text-left tw-px-6 tw-py-5 tw-transition-colors hover:tw-bg-gray-50"
                                                onClick={() => toggleAccordion(currentIndex)}
                                            >
                                                <div className={`accordion-icon tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-bg-indigo-50 tw-text-indigo-600 tw-mr-4 tw-transition-transform ${isOpen ? 'tw-rotate-180' : ''}`}>
                                                    <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                                    </svg>
                                                </div>
                                                <span className="tw-text-lg tw-font-medium tw-text-gray-900">{item.question}</span>
                                            </button>
                                            <div className={`faq-body tw-transition-all ${isOpen ? 'tw-max-h-96 tw-opacity-100 tw-py-6 tw-px-6 tw-pt-0' : 'tw-max-h-0 tw-opacity-0'}`}>
                                                <div className="tw-text-gray-600 tw-leading-relaxed">
                                                    {item.answer}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        ))
                    )}
                </div>
            </div>

            <Footer />
        </div>
    );
};
